import React from "react";
import "./flexStyles.scss";

const FlexColumn = React.forwardRef(({
  justifyContent = "center",
  alignItems = "center",
  flexWrap = "wrap",
  width = "100%",
  gap = "1rem",
  className = '',
  onClick = null,
  styles,
  children
}, ref) => {
  return (
    <div
      ref={ref}
      className={`flex-box-flex-column ${className}`}
      style={{
        justifyContent,
        alignItems,
        flexWrap,
        gap,
        width,
        ...styles
      }}
      onClick={() => {
        if (onClick) onClick();
      }}
    >
      {children}
    </div>
  );
})

export default FlexColumn;
